import { Component, ElementRef, HostListener, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatMenuModule, MatMenuTrigger} from '@angular/material/menu';
import { NgbCollapse, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from '../_services/local-storage.service';
import { LoginService } from '../_services/login.service';
import { TransactionService } from '../_services/transaction.service';
import { PersonSearchService } from '../_services/person-search.service';
import { GlobalService } from '../_services/global.service';
import { INavbarModule } from '../sidenavbar.module';
import { DataService } from "../data.service";
import { AiSourcingHandlerService } from '../_services/ai-sourcing-handler.service';
import { Subject } from 'rxjs';
import { CreateTalentpoolComponent } from '../talentpool/create-talentpool/create-talentpool.component';
import { DefaultLocationModalComponent } from '../default-location-modal/default-location-modal.component';
import { HireFilterComponent } from '../hire-person-search/hire-filter/hire-filter.component';
import { HiringCriteriaComponent } from '../hire-person-search/hiring-criteria/hiring-criteria.component';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
/*********************** navbar code import start*********************************** */
declare const clevertap;

type TourItem = { tour_id?: number, tour_config?: { subtitle?: string, icon?: string, gif_url?: string, allow_skip?: boolean, allow_video?: boolean, yt_video_id?: string }, module?: string, title: string, position?: number, isactive?: boolean };
/*********************** navbar code import end*********************************** */
@Component({
  selector: 'app-hire-sidebar',
  imports: [RouterModule, MatMenuModule, CommonModule,NgbCollapse,MatTooltipModule],
  templateUrl: './hire-sidebar.component.html',
  styleUrl: './hire-sidebar.component.scss',
  standalone: true,
})
export class HireSidebarComponent {
  @ViewChild(MatMenuTrigger) trigger:MatMenuTrigger
  buttonCliked:boolean=false
  isHovered = false;

  /********** Navabr varibales*********************** */
  successMessage: any;
  errorMessage: string;
  candidateSubject:Subject<any> = new Subject();
  @ViewChild('noCreditTalentpool') noCreditTalentpool: TemplateRef<any>;
  subscriptiondetails: any = {};
  isteamMember: boolean;
  userdata: any
  routeCheckForScrollNavabar:any

  /**
   * Store all tour items
   */
  tourItems: TourItem[] = [];
  defaultContinent: string;

  /********** sidebar varibales ******************* */
    isActive : boolean = false;
    isSearchActive: boolean = false;
    isSearchToolboxV2Active: boolean = false;
    isCompanyPagesActive: boolean = false;
    isPersonSearchActive: boolean = false;
    isHireSearchActive:boolean =false
    isCandidateListActive:boolean =false
    isAiSourcingActive: boolean = false;
    isNLSearchActive:boolean = false;
    atsResumeScreeningActive: boolean = false;
    isTalentpoolInsightPagesActive:boolean = false;
    get navModules(): INavbarModule[] {
      return this.dataService.getNavModules || [];
    }
ufname: any;
isCollapseOpen = false;
isDropDownOpen = false;
// private _isOpen = false;

// get isOpen() {
//   return this._isOpen;
// }

// set isOpen(value: boolean) {
//   this._isOpen = value;

//   // 🔥 whenever dropdown closes → reset collapse
//   if (!value) {
//     this.isCollapseOpen = !this.isCollapseOpen;
//   }
// }
   constructor(public modalService: NgbModal,private _localstorageservice : LocalStorageService ,private loginservice : LoginService, private dataService: DataService,
       private localStorageService: LocalStorageService,
       private aiSourcingHandlerService: AiSourcingHandlerService,
    private router : Router ,private transactionservice:TransactionService, private personSearchService: PersonSearchService, private globalService: GlobalService,private route: ActivatedRoute,private el: ElementRef<HTMLElement>) { }
  ngOnInit() {
    /******************** navbar ngOnInit code start ******************************/
     this.userdata = this._localstorageservice.getItem('userdata')
    this.transactionservice.getPaymentData().subscribe(event => {
      this.userdata = this._localstorageservice.getItem('userdata')
    });

    this.routeCheckForScrollNavabar=  this.router.url.includes('/person/search/listing')

    this.getAllToursData();

    /******************** navbar ngOnInit code end ******************************/

    /******************** previous sidebar ngOnInit code start ******************************/
if (this.router.url.includes('talent/talentpool')){
      this.isActive = true
    }
    else if (this.router.url.includes('smartsearch')){
      this.isSearchActive = true
    }
    else if (this.router.url.includes('searchtoolbox-v2')){
      this.isSearchToolboxV2Active = true
    }
    else if(this.router.url.includes('company-directory')){
      this.isCompanyPagesActive = true;
    }
    else if(this.router.url.includes('person-search')){
      this.isPersonSearchActive = true;
    }
    else if(this.router.url.includes('search')){
      this.isHireSearchActive = true;
    }
     else if(this.router.url.includes('candidate-list')){
      this.isCandidateListActive = true;
    }
    else if(this.router.url.includes('ai-sourcing')){
      this.isAiSourcingActive = true;
    }
    else if(this.router.url.includes('nl-search')){
      this.isNLSearchActive = true;
    }
    else if(this.router.url.includes('resume-screen')){
      this.atsResumeScreeningActive = true;
    }
     else if(this.router.url.includes('talentpool-insights')){
      this.isTalentpoolInsightPagesActive = true;
    }
    /******************** previous sidebar ngOnInit code end ******************************/
    this.ufname = this._localstorageservice.getItem('ufname')

  }
  dropdownMenuShow(){
    this.buttonCliked=true;
    this.isHovered = true;
  }

onMouseEnter() {
  this.isHovered = true;
  // this.trigger.toggleMenu()
  // this.isDropDownOpen = true
}

onMouseLeave() {
  this.isHovered = false;
  // this.trigger.closeMenu()
  // this.isDropDownOpen = false
  this.isCollapseOpen = true

}
toggleDropdown(event: Event) {
  event.stopPropagation(); // prevent bubbling
  this.isDropDownOpen = !this.isDropDownOpen;

  //🔥 when closing manually, reset collapse
  // if (!this.isDropDownOpen) {
  //   this.isCollapseOpen = false;
  // }
}

// Close only when clicking outside
@HostListener('document:click')
closeDropdown() {
  this.isDropDownOpen = false;
  //  this.isCollapseOpen = false; // 🔥 reset collapse
}

toggleCollapse(event: Event) {
   event.preventDefault();      // 🔥 stops <a> behavior
  event.stopPropagation();     // 🔥 stops dropdown close
  this.isCollapseOpen = !this.isCollapseOpen;
  // if (!this.isDropDownOpen) {
  //   this.isCollapseOpen = false
  // }
}

  @HostListener('document:click', ['$event'])
  onDocClick(e: MouseEvent) {
    if (!this.el.nativeElement.contains(e.target as Node)) {
      this.isHovered = false;
    }
  }
onOutsideClick() {
  // this.isDropDownOpen = false; // setter will reset collapse automatically
  // this.isCollapseOpen = false
}

// toggleCollapse(e: Event) {
//   e.preventDefault();
//   e.stopPropagation();
//   const el = document.getElementById('collapseExample');

// }
///******************** previous sidebar code start ******************************/
// toolbox code
  Route2ToolBox(toolboxVersion: string){
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      if (toolboxVersion === 'version1.0') {
        this.router.navigate(['/smartsearch']);
      } else if (toolboxVersion === 'version2.0') {
        this.router.navigate(['/searchtoolbox-v2']);
      }
    });
  }

// clevertap code
  getCleverTapEvents(type) {
    if (type == 'Ai Sourcing') {
      this.aiSourcingHandlerService.setDisplayPageEvent('ai-sourcing');
    };
    const navbarParams = {
      "User ID": this.localStorageService.getItem('userdata').userid,
      "type": type
    }
    clevertap.event.push('Navbar Click', navbarParams);
  }

  goToDefault() {
    this.router.navigate(['/search']);
  }
///******************** previous sidebar code end ******************************/

///******************** previous navbar  code start ******************************/

// Logout
  // logout(){
  // let userid = this._localstorageservice.getItem('userid')
  // let userno = this._localstorageservice.getItem('usernumber')
  // let ufname = this._localstorageservice.getItem('ufname')
  // let ulname = this._localstorageservice.getItem('ulname')

  //  let data ={
  //    email : "'" + this._localstorageservice.getItem('usermailid') + "'"
  //  }
  //  this.loginservice.logOut(data).subscribe((res:any)=>{
  //    if(res.status == 'success'){
  //     let chromeid = localStorage.getItem('extensionID');
  //     if(chromeid){
  //     try {
  //       window['chrome'].runtime.sendMessage(chromeid, {action: 'logout', usernumber: userno, userid: userid, firstname: ufname, lastname: ulname});
  //      }
  //      catch (error) {
  //       console.error('Here is the error message', error);
  //      }
  //     }
  //     this.router.navigateByUrl('/login')
  //     localStorage.clear();
  //     sessionStorage.clear();
  //     localStorage.setItem('extensionID', chromeid)
  //    }
  //  })

  // }

    /**
     * Fetch all tours data via service
     */
    getAllToursData() {
      this.personSearchService.getPersonSearchTours({}).subscribe((res: any) => {
        if(res && res.status === 'success') {
          this.tourItems = res.data;
             this.defaultContinent = this._localstorageservice.getItem('defaultContinent');
      if(!this.defaultContinent)
         this.openDefaultContinentModal();
        } else {
          console.log("getPersonSearchTours failure res", res);
        }
      }, (err: any) => {
        console.log("getPersonSearchTours failure err", err);
      })
    }

    toastmessage(message, type) {
      if (type == 'success') {
        this.successMessage = message;
        setTimeout(() => this.successMessage = '', 5000);
      } else if (type == 'error')
        this.errorMessage = message;
      setTimeout(() => this.errorMessage = '', 5000);
    }


    openCreateCandidate(){
      // const modalRef = this.modalService.open(CreateCandidateComponent, { size: 'lg' as 'lg', backdrop: 'static', keyboard: false ,windowClass: 'custom-class' });
      document.getElementById("mySidebar").style.display = "block";
      document.getElementById("myOverlay").style.display = "block";
      this.candidateSubject.next(undefined as any);

    }

    openCreateTalentpool(){
     // if(this._localstorageservice.getItem('tpcredits') > 0){
      const modalRef = this.modalService.open(CreateTalentpoolComponent, { size: 'lg' as 'lg', backdrop: 'static', keyboard: false ,centered: true,});
      modalRef.componentInstance.passEntry.subscribe((x) => {
        if (x == 'talentpool-added') {
          this.toastmessage('Talentpool Created Succesfully', 'success')
          this.fetchcredits()
      }
      // else if(x == 'notpcredits'){
      //   const modalRef = this.modalService.open(this.noCreditTalentpool,{ windowClass: "myCustomModalClass", centered: true });
      //   this.sendmailexpiry('Talent Pipeline credits')
      // }
      else if(x =='error'){
        this.toastmessage('Something went wrong, Please try again in a minute', 'error')
      }})
    //}
      // }else{
      //   let clevertap_data = {
      //     "Talent Pool Name" : 'null',
      //   }
      //   this.cleverTapEvent("TalentPool_CreditExpiry", clevertap_data);
      //   const modalRef = this.modalService.open(this.noCreditTalentpool,{ windowClass: "myCustomModalClass", centered: true });
      //   this.sendmailexpiry('Talent Pipeline credits')
      // }
    }

    logout(){
    let userid = this._localstorageservice.getItem('userid')
    let userno = this._localstorageservice.getItem('usernumber')
    let ufname = this._localstorageservice.getItem('ufname')
    let ulname = this._localstorageservice.getItem('ulname')

     let data ={
       email : "'" + this._localstorageservice.getItem('usermailid') + "'"
     }
     this.loginservice.logOut(data).subscribe((res:any)=>{
       if(res.status == 'success'){
        let chromeid = localStorage.getItem('extensionID');
        if(chromeid){
        try {
          window['chrome'].runtime.sendMessage(chromeid, {action: 'logout', usernumber: userno, userid: userid, firstname: ufname, lastname: ulname});
         }
         catch (error) {
          console.error('Here is the error message', error);
         }
        }
        this.router.navigateByUrl('/login')
        localStorage.clear();
        sessionStorage.clear();
        localStorage.setItem('extensionID', chromeid)
       }
     })

    }

    route2pricing(){
      this.modalService.dismissAll()
      this.router.navigateByUrl('/subscription/usage')
    }

    fetchcredits(){
      // Credits come from the shared signal (populated only on login and after reveal-contact
      // succeeds, see TransactionService) - this no longer calls /paymentflow/fetchcurrentplancredits.
      // Team-admin/team-member branching is already resolved on the signal's payload.
      const creditsData = this.transactionservice.credits();
      if (creditsData) {
        this._localstorageservice.setItem('userPlanData', creditsData);
        this.isteamMember = !!creditsData.teamadmindetails;
        this.subscriptiondetails.balancecontactenrichmentcredits = creditsData.balancecontactenrichmentcredits;
        this.subscriptiondetails.balancejdparsingcredits = creditsData.balancejdparsingcredits;
        this.subscriptiondetails.balancesmartemailcredits = creditsData.balancesmartemailcredits;
        this.subscriptiondetails.balancetalentpipelinecredits = creditsData.balancetalentpipelinecredits;

        this._localstorageservice.setItem('jdcredits', this.subscriptiondetails.balancejdparsingcredits)
        this._localstorageservice.setItem('tpcredits', this.subscriptiondetails.balancetalentpipelinecredits)
        this._localstorageservice.setItem('cecredits', this.subscriptiondetails.balancecontactenrichmentcredits)
        this._localstorageservice.setItem('secredits', this.subscriptiondetails.balancesmartemailcredits);
      }

      // Access comes from the shared signal (populated on login, on navigation into an
      // access-gated route via AccessRefreshGuard, and force-refreshed on continent change) -
      // talentpool creation doesn't change access, so there's no reason to call the API again here.
      const accessData = this.transactionservice.access();
      if (accessData) {
        this._localstorageservice.setItem('hasEUPersonSearchAccess', accessData.haseupersonsearchaccess);
        this._localstorageservice.setItem('hasEUTalentInsightsAccess', accessData.haseutalentinsightsaccess)
        let userPlanData = this._localstorageservice.getItem('userPlanData');
        userPlanData = {...userPlanData, ...accessData}
        this._localstorageservice.setItem('userPlanData', userPlanData);

        const currentRegion = this._localstorageservice.getItem('region');
        if(currentRegion == 'europe' && !accessData.haseupersonsearchaccess) {
          this.personSearchService.getGeoIpLocationOfUser.subscribe((response: any) => {
            const region = response.continent ? response.continent.toLowerCase() : 'asia';
            this._localstorageservice.setItem('region', region);
          });
        }

        const currentTIRegion = this._localstorageservice.getItem('talentRegion');
        if(currentTIRegion == 'europe' && !accessData.haseutalentinsightsaccess) {
          this.personSearchService.getGeoIpLocationOfUser.subscribe((response: any) => {
            const region = response.continent ? response.continent.toLowerCase() : 'asia';
            this._localstorageservice.setItem('talentRegion', region);
          });
        }
      }
    }

    sendmailexpiry(type){
      let data ={
        expiredmetric : type
      }
      this.transactionservice.sendcreditexpirymail(data).subscribe()
    }
    cleverTapEvent(eventName, data) {
      clevertap.event.push(eventName, data);
      console.log(eventName + " CT event");
    }

    initiatechat() {
      const user = this._localstorageservice.getItem('ufname') + ' ' + this._localstorageservice.getItem('ulname')
      const user_email = this._localstorageservice.getItem('usermailid')
      if(window['fcWidget']) {
        window['fcWidget'].setExternalId(user_email);

        window['fcWidget'].user.setFirstName(user);
        window['fcWidget'].user.setEmail(user_email);
        window['fcWidget'].user.setProperties({
          plan: "Pro",
          status: "Active"
        });

        if(window['fcWidget'].isOpen()) {
          window['fcWidget'].close()
        } else {
          window['fcWidget'].open()
        }
      }

    }

    /**
     * Jump directly to specific item from the tours data list
     * @param itemId page/position to jump to
     */
    goToTour(itemId: number) {
      this.globalService.openTourModal({ pageToJump: (itemId - 1) });
    }

        openDefaultContinentModal() {
            const modalRef = this.modalService.open(DefaultLocationModalComponent, {  windowClass: 'NLSearchMdmodal', centered: true, backdrop: 'static', keyboard: false });
            modalRef.componentInstance.modalDismissEvent.subscribe((res) => {
              if(res === 'success'){
                this.toastmessage('Default continent set successfully', 'success');
              }
          }  )

        }

    /**
     * Helper method to check if extension is installed
     */
    isExtensionInstalled = GlobalService.isExtensionInstalled;


    // new Filter Revamp modal open code
      openFilterModal(){
        console.log('hi')
        this.modalService.open(HireFilterComponent,{windowClass:'hireFiltermodal', centered: true, backdrop: 'static', keyboard: false})
      }
       openHiringCriteriaModal(){
        console.log('hi')
        this.modalService.open(HiringCriteriaComponent,{windowClass:'hireFiltermodal', centered: true, backdrop: 'static', keyboard: false})
      }

  ///******************** previous navbar  code end ******************************/
}
